import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"

export const authentication = {
    authenticate,
    forgotPassword,
    acceptInvite,
    changePassword,
}

async function authenticate({
    username,
    password,
    two_factor_method,
    provider = "EMAIL",
    organisation_id,
    sso_provider,//{token, state}
    schedulingTeam
}, accessToken) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/users/authenticate',
            logOutIfSessionInvalid: false,
            withoutApikey: true,
            body: {
                username,
                password,
                two_factor_method,
                provider,
                organisation_id,
                sso_provider,
            },
            accessToken
        });

        console.log("AAAA authenticate response: ", response)
        if (response.code == 'OK') {
            if (response.data.two_factor_required && response.data.two_factor_required == true) {
                httpBackOfficeUtil.startSessionForVerify(response.data)
            }
            else {
                httpBackOfficeUtil.clearSessionForVerify();
                httpBackOfficeUtil.startSession(response.data)
                let isSelfSchedulingUser = await checkSelfSchedulingUser({
                    schedulingTeam: schedulingTeam,
                    first_name: response.data.user.first_name,
                    last_name: response.data.user.last_name
                });
                // console.log("isSelfSchedulingUser: ", isSelfSchedulingUser);
                httpBackOfficeUtil.saveSelfSchedulingUser(isSelfSchedulingUser);
            }
            return createResult(ErrorCodes.OK, response.data)
        } else {
            if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION" || response.error && response.error.error == "CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION")) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else if (response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.EMAILNOTVERIFIEDEXCEPTION") {
                return createResult(ErrorCodes.EMAIL_NOT_VERIFIED, response.error);
            }
            else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (error) {
        console.log("AAAA authenticate exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function checkSelfSchedulingUser({
    page = 1,
    size = 10,
    include_total = true,
    is_active = true,
    email_address,
    first_name,
    last_name,
    schedulingTeam
} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/users',
            queryParams: {
                page,
                size,
                include_total,
                is_active,
                email_address,
                first_name,
                last_name
            },
            withAccessToken: true
        });

        if (response.code == 'OK') {
            let data = response.data.content ? response.data.content : [];

            if (data.length > 0) {
                let userDt = data[0];
                if (userDt && userDt.teams && userDt.teams.length > 0) {
                    for (let i = 0; i < userDt.teams.length; i++) {
                        let team = userDt.teams[i];

                        if (team && team.name === schedulingTeam)
                            return true;
                    }
                }

            }
        }
        return false;
    } catch (e) {
        console.log('Exception checkSelfSchedulingUser: ', e);
        return false;
    }
}

async function forgotPassword({ email }) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/users/forgot_password',
            logOutIfSessionInvalid: false,
            withoutApikey: true,
            body: {
                email
            },
        });

        console.log("AAAA forgotPassword response: ", response)
        if (response.code == 'OK') {
            return createResult(ErrorCodes.OK, response.data)
        } else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (error) {
        console.log("AAAA authenticate exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function acceptInvite({
    token,
    password,
}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/users/accept_invite',
            logOutIfSessionInvalid: false,
            body: {
                token,
                password,
            },
        });
        console.log("AAAA acceptInvite response: ", response)
        if (response.code == 'OK') {
            return createResult(ErrorCodes.OK, response.data)
        } else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (error) {
        console.log("AAAA acceptInvite exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function changePassword({
    token,
    password,
}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/users/change_password',
            logOutIfSessionInvalid: false,
            body: {
                token,
                password,
            },
        });

        console.log("AAAA changePassword response: ", response)
        if (response.code == 'OK') {
            return createResult(ErrorCodes.OK, response.data)
        } else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (error) {
        console.log("AAAA changePassword exception: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}
